<template>
  <div id="program-rate-dialog" class="custom-modal">
    <div class="modal-body">
      <div>
        <transition name="el-fade-in" mode="out-in">
          <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />

          <el-row v-else key="content-loading">
            <el-col :span="24" class="mb-2">
              <el-button type="primary" icon="fas fa-search" size="mini" @click="isFilterEnabled = !isFilterEnabled" round>{{ $t("components.eventprogram.eventProgramRate.filter") }}</el-button>
            </el-col>
            <transition name="el-zoom-in-top" mode="out-in">
              <el-col :span="24" v-if="isFilterEnabled">
                <div class="mb-2 automated-message-filter">
                  <div class="filter-body">
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="24">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.eventprogram.eventProgramRate.search") }}</label>
                          </div>
                          <el-input v-model="filter.searchTerm" clearable :placeholder="$t('components.eventprogram.eventProgramRate.searchPlaceholder')" @clear="filter.searchTerm = null"></el-input>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                      <el-col :span="12" class="mt-2">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.eventprogram.eventProgramRate.participantNumber") }}</label>
                          </div>
                          <el-input v-model="filter.participantNo" :placeholder="$t('components.eventprogram.eventProgramRate.participantNumberPlaceholder')" @clear="filter.participantNo = null" clearable></el-input>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>

                      <el-col :span="12" class="mt-2">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("components.eventprogram.eventProgramRate.status") }}</label>
                          </div>
                          <el-select v-model="filter.status" :placeholder="$t('components.dashboard.onsite.placeholderAll')" clearable @clear="filter.status = null" filterable>
                            <el-option v-for="(option, index) in getEnums.find(x => x.title == 'ProgramRateStatus').enums" :label="option.displayName" :value="option.key" :key="index"></el-option>
                          </el-select>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="filter-footer d-flex justify-content-between mt-2">
                    <div class="left-buttons">
                      <el-button size="mini" @click="isFilterEnabled = !isFilterEnabled">{{ $t("components.eventprogram.eventProgramRate.close") }}</el-button>
                    </div>
                    <div class="right-buttons">
                      <el-button size="mini" @click="filterReset" type="primary">{{ $t("components.eventprogram.eventProgramRate.reset") }}</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </transition>
            <upgrade-overlay height="300px" v-if="false"></upgrade-overlay>
            <el-col :span="24" v-else-if="rateList.length > 0">
              <div class="custom-grid-table-header program-rate-header">
                <span>{{ $t("components.eventprogram.eventProgramRate.participant") }}</span>
                <span>{{ $t("components.eventprogram.eventProgramRate.evaluation") }}</span>
              </div>
              <div class="program-rate-container">
                <div class="item" v-for="item in rateList" :key="item.id">
                  <div class="participant-card-mini mini align-items-center" v-if="item.participant != null">
                    <div class="participant-card-mini-right justify-content-center">
                      <div class="participant-card-mini-num d-block"># {{ item.participant.participantNO }}</div>
                      <div class="participant-card-mini-title">{{ item.participant.firstName }} {{ item.participant.lastName }}</div>
                      <div class="participant-card-mini-container">
                        <span>
                          <i class="fas fa-circle" :style="{ color: item.participant.tag.color }"></i>
                          {{ item.participant.tag.title }}
                        </span>
                        <span v-if="item.targetAddress != null">{{ item.targetAddress }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="item-rate">
                    <div class="rate-content">
                      <span class="text-1" v-if="item.program != null">{{ item.program.title }}</span>
                      <span class="rate-flex">
                        <el-rate :value="item.rate" :disabled="true" text-color="#ff9900" disabled-void-color="#e2e2e2"></el-rate>
                        <div class="rate-score">{{ item.rate }}</div>
                      </span>
                      <span v-if="item.comment != null && item.comment != ''">{{ item.comment }}</span>
                      <span class="text-2">{{ $moment(item.createDate).format("DD MMMM YYYY, dddd") }}</span>
                    </div>
                    <div class="rate-status">
                      <span class="text-3">{{ $t("components.eventprogram.eventProgramRate.status") }}</span>
                      <el-dropdown placement="bottom-start">
                        <span class="status" :class="{ 'payment-awaiting': item.status == 0, rejected: item.status == 2, confirmed: item.status == 1 }">
                          <i class="fas " :class="{ 'fa-clock': item.status == 0, 'fa-check': item.status == 1, 'fa-times-circle': item.status == 2 }"></i>
                          {{ getEnumsDisplay("ProgramRateStatus", item.status) }}
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item class="status-pending-approve" v-if="item.status == 0" @click.native="changeRateStatus(item.id, 1)">
                            <i class="fas fa-check"></i>
                            {{ $t("components.eventprogram.eventProgramRate.confirm") }}
                          </el-dropdown-item>
                          <el-dropdown-item class="status-pending-reject" v-if="item.status == 0" @click.native="changeRateStatus(item.id, 2)">
                            <i class="fas fa-times"></i>
                            {{ $t("components.eventprogram.eventProgramRate.reject") }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <span class="text-2">{{ $moment(item.createDate).format("DD MMMM YYYY, dddd") }}</span>
                    </div>
                    <div class="d-flex align-items-center justify-content-end">
                      <el-tooltip effect="dark" :content="$t('event.table.delete')" placement="top">
                        <el-popconfirm @confirm="deleteRate(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                          <el-button type="danger" slot="reference" :loading="loading == 'deleteItem-' + item.id" :disabled="loading == 'deleteItem-' + item.id" icon="fas fa-trash" circle size="mini"></el-button>
                        </el-popconfirm>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="24" v-else>
              <div>
                <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-rate-lottie'" :title="$t('contentManagement.eventProgram.ratings')" @btnAdd="false" @btnRefresh="false" :buttonAdd="false" :buttonRefresh="false" :loading="loading" />
              </div>
            </el-col>
          </el-row>
        </transition>
      </div>
    </div>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("components.eventprogram.eventProgramRate.close") }}</el-button>
      </div>
      <div class="center-buttons"></div>
      <div class="right-buttons" v-if="rateList.length > 0">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="filter.take" layout="total,sizes,prev, pager, next" :total="filter.total"></el-pagination>
        <!-- <el-button type="primary" @click="openExcellDialog">İndir</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      loading: false,
      timeout: null,
      isFilterEnabled: false
    };
  },
  methods: {
    filterReset() {
      this.filter.participantNo = null;
      this.filter.searchTerm = null;
      this.filter.status = null;
      this.isFilterEnabled = false;
    },
    async deleteRate(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout ==
        setTimeout(async () => {
          await this.$store.dispatch("deleteEventProgramRate", id);
          this.loading = false;
        }, 500);
    },
    async changeRateStatus(id, type) {
      var payload = {
        id: id,
        status: type
      };
      await this.$store.dispatch("changeEventProgramRateStatus", payload);
    },
    handleSizeChange(take) {
      this.filter.take = take;
    },
    handleCurrentChange(page) {
      this.filter.page = page;
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      this.filter.programId = null;
      if (this.id != null && this.id != undefined) {
        this.filter.programId = this.id;
      }
      await this.$store.dispatch("getEventProgramRate");
      this.loading = false;
    }, 500);
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    rateList() {
      return this.$store.getters.getEventRateList;
    },
    filter() {
      return this.$store.getters.getEventRateFilter;
    }
  },
  watch: {
    filter: {
      deep: true,
      async handler() {
        this.loading = "filterSearch";
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await this.$store.dispatch("getEventProgramRate");
        }, 500);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.program-rate-header {
  grid-template-columns: 200px 1fr !important;
}
.program-rate-container {
  display: flex;
  flex-direction: column;
  .item {
    transition: all 0.5s;
    border-radius: 8px;
    background-color: #f1f1f1;
    margin-bottom: 8px;
    padding: 10px;
    gap: 0.5rem;
    align-items: center;

    &:last-child {
      margin-bottom: unset;
    }
    &.passive {
      background-color: #fff2f2 !important;
    }
    .text-1 {
      color: #03658c;
      text-decoration: underline;
      font-weight: 600;
      font-size: 12px;
    }
    .text-2 {
      font-size: 12px;
      font-weight: 600;
    }
    .text-3 {
      font-weight: 500;
      color: #292f3b;
      font-size: 12px;
    }
    display: grid;
    grid-template-columns: 200px 1fr;
    & > .item-rate {
      display: grid;
      grid-template-columns: 1fr 170px 90px;
      .rate-status {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      .rate-content {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .rate-flex {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          .rate-score {
            padding: 4px;
            min-width: 40px !important;
            align-items: center;
            text-align: center;
            background-color: #e2e2e2;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.rate-status {
  & > .el-dropdown {
    & > .status {
      display: block;
      width: fit-content;
      padding: 5px 10px;
      border-radius: 8px;
      color: #292f3b;
      font-weight: 500;

      i {
        margin-right: 8px;
      }
      &.pending {
        background: #f1f1f1;
        cursor: pointer;
        i {
          color: #292f3b;
        }
      }
      &.payment-awaiting {
        background: #fff2e5;
        i {
          color: #f98559;
        }
      }
      &.confirmed {
        background: #e5fff8;
        i {
          color: #50bfbf;
        }
      }
      &.rejected {
        background: #ebdcdc;
        i {
          color: #ff6565;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eventprogram/EventProgramRate.vue